export default {
  back: 'Retour aux campagnes',
  title: 'Campagne',
  sent_at: 'Envoyé {{time}}',
  breakdown_title: 'Résumé de livraison',
  pending_receipts: {
    title: 'Les stats de livraison arrivent',
    description:
      "Cette campagne vient d'être envoyée. Les fournisseurs push confirment la livraison environ 15 minutes après l'envoi, les chiffres ci-dessous seront disponibles vers {{time}} — aucune action requise.",
    countdown:
      'Apple et Google confirment les accusés de réception dans environ {{minutes}}m {{seconds}}s (vers {{time}}). Les stats seront actualisées automatiquement.',
    ready:
      "Les accusés de réception devraient être disponibles. Les chiffres ci-dessous sont en cours d'actualisation.",
    soon: 'bientôt',
  },
  recipients: {
    title: 'Destinataires',
    subtitle: 'À qui cette campagne a été envoyée et si elle a atteint leur appareil.',
    filters: {
      all: 'Tous',
      delivered: 'Livré',
      pending: 'En attente de confirmation',
      failed: 'Non livré',
    },
    columns: {
      recipient: 'Destinataire',
      status: 'Statut',
      reason: 'Raison',
      clicked: 'Cliqué',
      sent_at: 'Envoyé le',
    },
    status: {
      delivered: 'Livré',
      pending: 'En attente de confirmation',
      failed: 'Non livré',
    },
    reasons: {
      DeviceNotRegistered: 'Application supprimée ou notifications désactivées (jeton expiré)',
      MessageRateExceeded: 'Temporairement limité par Expo',
      MessageTooBig: 'Charge utile de notification trop volumineuse',
      MismatchSenderId: 'Identifiants push non concordants',
      InvalidCredentials: 'Identifiants push invalides',
      batch_failed: "Échec de l'envoi par lot",
      missing_ticket: 'Aucune confirmation retournée par Expo',
      unknown: 'Erreur de livraison inconnue',
    },
  },
};
